import Layout from '@components/Layout';
import Login from '@containers/Login';
import { middlewareLogin } from '@helpers/middleware';
import { ITitle } from '@interfaces/ITitle';
import type { NextPage, NextPageContext } from 'next';

const LoginPage: NextPage<ITitle> = ({ title }): JSX.Element => {
  return (
    <Layout
      title={title}
      isNavbar={false}
      isSidebar={false}
      isFullWidth
      bgImage={`linear-gradient(rgba(18,34,56,0.45), rgba(18,34,56,0.45)), url('/img/login/login-bg.webp')`}
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      isAuthLayout
      position="relative"
    >
      <Login />
    </Layout>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  return middlewareLogin(context, {
    title: 'Login',
  });
}
export default LoginPage;
